import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BackgroundImageDirective } from './directives';

@NgModule({
  declarations: [
    BackgroundImageDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    BackgroundImageDirective
  ]
})
export class SharedComponentsModule {
}
